(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    function scrollBreadcrumbsToEnd() {
    const container = document.getElementById('breadcrumbs-container');
    if (container && container.scrollWidth > container.clientWidth) {
      container.scrollLeft = container.scrollWidth;
    }
  }

  document.addEventListener('filters-applied', scrollBreadcrumbsToEnd);
  document.addEventListener('DOMContentLoaded', scrollBreadcrumbsToEnd);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.target.id === 'breadcrumbs') {
        scrollBreadcrumbsToEnd();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const breadcrumbs = document.getElementById('breadcrumbs');
    if (breadcrumbs) {
      observer.observe(breadcrumbs, { childList: true, subtree: true });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
